module.exports = __webpack_public_path__ + "static/media/fast-food-gastronomy-3-svgrepo-com.693e9bef.svg";